import { createContext } from 'react';

// The mounted Activities account owns this coordinator; individual editors only
// subscribe. Standalone Activity intentionally falls back to mount-local scope.
export const WorkoutStartContext = createContext(null);
